import { render, staticRenderFns } from "./TabbedPortletBodyTab.vue?vue&type=template&id=acab6f52&"
import script from "./TabbedPortletBodyTab.vue?vue&type=script&lang=js&"
export * from "./TabbedPortletBodyTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports